import { ColumnsRequest, ColumnsResponse } from './types';
import { parseSchema } from './ddlParser';
import * as onboardingApi from './onboardingApi';

export type SchemaSource =
  | { kind: 'paste'; text: string }
  | { kind: 'redshift'; request: ColumnsRequest };

export interface SchemaProvider {
  getColumns(source: SchemaSource): Promise<ColumnsResponse>;
}

export class SchemaParseError extends Error {
  // NOTE: declare + assign explicitly rather than using the TS parameter-property
  // shorthand `constructor(public code: ...)` — this package's babel-loader does not
  // strip the `public` modifier, which leaks into the output JS as a reserved word.
  code: string;
  constructor(code: string, message: string) {
    super(message);
    this.code = code;
    this.name = 'SchemaParseError';
  }
}

export const localSchemaProvider: SchemaProvider = {
  async getColumns(source) {
    if (source.kind !== 'paste') {
      throw new SchemaParseError(
        'REDSHIFT_NOT_AVAILABLE',
        'Redshift introspection is not available yet (Spec 1). Paste DDL, CSV, or JSON instead.',
      );
    }
    return parseSchema(source.text);
  },
};

export const backendSchemaProvider: SchemaProvider = {
  async getColumns(source) {
    if (source.kind === 'paste') {
      return onboardingApi.parseDdl({ ddl: source.text });
    }
    return onboardingApi.listColumns(source.request);
  },
};

export const schemaProvider: SchemaProvider = localSchemaProvider;
